"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import { Skeleton } from "@/components/ui/skeleton";
import { TRUSTPILOT_READY_EVENT } from "./TrustpilotScript";
const TEMPLATE_ID = "544a426205dc0a09088833c6";
interface Props {
  skus: string[];
}
export function TrustpilotWidget(t0) {
  const $ = _c(7);
  const {
    skus
  } = t0;
  const ref = useRef(null);
  let t1;
  if ($[0] !== skus) {
    t1 = skus.map(_temp).join(",");
    $[0] = skus;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const dataSku = t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const el = ref.current;
      if (!el) {
        return;
      }
      let loaded = false;
      let inView = false;
      const tryLoad = () => {
        if (loaded || !inView || document.visibilityState !== "visible" || !window.Trustpilot) {
          return;
        }
        loaded = true;
        window.Trustpilot.loadFromElement(el);
      };
      const observer = new IntersectionObserver(entries => {
        inView = entries.some(_temp2);
        tryLoad();
      });
      observer.observe(el);
      document.addEventListener("visibilitychange", tryLoad);
      window.addEventListener(TRUSTPILOT_READY_EVENT, tryLoad);
      return () => {
        observer.disconnect();
        document.removeEventListener("visibilitychange", tryLoad);
        window.removeEventListener(TRUSTPILOT_READY_EVENT, tryLoad);
      };
    };
    t3 = [];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Skeleton className="w-full h-175" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== dataSku) {
    t5 = <div ref={ref} className="trustpilot-widget w-full" data-locale="en-US" data-template-id={TEMPLATE_ID} data-businessunit-id={process.env.NEXT_PUBLIC_TRUSTPILOT_BUSINESS_UNIT_ID} data-style-height="700px" data-style-width="100%" data-review-languages="en" data-no-reviews="hide" data-fullwidth="true" data-sku={dataSku}>{t4}</div>;
    $[5] = dataSku;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}
function _temp2(entry) {
  return entry.isIntersecting;
}
function _temp(s) {
  return s.replace(/\s/g, "");
}